import React from "react";
import "./how-to-buy.scss";
import { withRouter } from "react-router";
import { Row, Col } from "reactstrap";
import HowToCard from "../../common/cards/HowToCard";

class HowToBuy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      device: "web",
      steps: [
        {
          image: require("../../../assets/images/landing/a.png"),
          title: "Select Your Plan",
          subtitle:
            "Check out our plan options, ‘Single’ and ‘Family’ and select a variant on the basis of your needs."
        },
        {
          image: require("../../../assets/images/landing/b.png"),
          title: "Talk to Us",
          subtitle:
            "Want someone to talk you through the process? Call us at +91-9389-9389-38."
        },
        {
          image: require("../../../assets/images/landing/c.png"),
          title: "Make a Payment",
          subtitle:
            "Just fill in the details online and buy yourself a Toffee Insurance Plan in no time."
        }
      ]
    };
  }
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  navigateToProduct() {
    this.props.history.push("/product/" + this.state.selectedPlan);
  }
  selectProduct(plan) {
    if (this.state.selectedPlan === plan) {
      this.state.device === "web" && this.navigateToProduct();
      return;
    }
    this.setState({
      selectedPlan: plan
    });
  }
  render() {
    return (
      <div className="how-to-buy-container">
        <h2 className="title opacity-90 text-center">
          How To Get Toffee Insurance
        </h2>
        <h3 className="sub-title font-weight-bold">Easy as A-B-C!</h3>
        <div className="box-container">
          <Row className="m-0 p-0">
            <Col lg="4" className="m-0 p-0 bb-1">
              <HowToCard data={this.state.steps[0]} />
            </Col>
            <Col lg="4" className="m-0 p-0">
              <HowToCard data={this.state.steps[1]} />
            </Col>
            <Col lg="4" className="m-0 p-0 bt-1">
              <HowToCard data={this.state.steps[2]} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(HowToBuy);
